import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-officesupplies',
  templateUrl: './icon-officesupplies.component.html',
  styleUrls: ['./icon-officesupplies.component.scss']
})
export class IconOfficesuppliesComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
